import React from 'react'
import {connect} from 'react-redux'

import '../../asset/less/component.css'
import '../../asset/less/Showcase.css'

import {Button, Col, Divider, Row, Spin} from 'antd'
import Title from 'antd/es/typography/Title'
import {withRouter} from 'react-router'
import {URL_NEW_COLLECTIONS, URL_SHOWCASE_ARTWORK, URL_SHOWCASE_BIO, URL_SHOWCASE_PUBLISH} from '../../const'
import ArtworkCollectionsPanel from '../../component/collection/ArtworkCollectionsPanel'
import BackButton from "../../component/base/BackButton";

@connect((state) => ({
    //decorator, gives component access to the state
    siderWidth: state.style.siderWidth,
    id: state.user.info.id,
    userId: state.user.info.userId,
    artistId: state.user.info.artistId,
    artistName: state.user.info.artistName
}))
class ShowcaseArtByCollection extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className='site-layout-background'>
                    <Row align='baseline' gutter={{xs: 8, sm: 16, md: 24}}
                         style={{marginTop: 12, justifyContent: "space-between"}}>
                        <Col style={{display: 'table', textAlign: "center", height: '100%'}}>
                            <Title level={1} style={{
                                marginBottom: 12,
                                marginTop: 12
                            }}>Artwork Display</Title>
                        </Col>
                    </Row>
                    <p>
                        <i>
                            Select artwork from your inventory and collections. Arrange your pieces as you would like viewers to see them in your showcase.{' '}
                            <a style={{color: 'black', textDecoration: 'underline'}}
                               href={'https://revart.co/sam/faqs/2.-Manage+The+Showcase'}>
                                Learn More
                            </a>
                            .
                        </i>
                    </p>
                    <Divider style={{marginBottom: 12, marginTop: 12}}/>
                <Row gutter={[32, 16]} style={{
                        backgroundColor: 'rgba(255,255,255,0.4)', position: 'fixed', zIndex: 1000, paddingLeft: 12,
                        paddingRight: 12, justifyContent: 'space-evenly', justifyItems: 'center',
                        left: this.props.siderWidth, width: '90%', bottom: 12, alignItems: 'center', flexDirection:"row"
                    }}>
                        <Col xs={12} sm={5} md={5} lg={3}>
                            <BackButton {...this.props} block/>
                        </Col>
                        <Col xs={12} sm={6} md={5} lg={4}>
                            <Button
                                onClick={(e) => {
                                    window.location.href = URL_SHOWCASE_PUBLISH
                                }}
                                block
                                type='primary'
                                size='middle'
                                htmlType='submit'
                                style={{float: "right"}}
                            >
                                Continue
                            </Button>
                        </Col>
                    </Row>
                    <ArtworkCollectionsPanel/>
                </div>
        )
    }
}

export default withRouter(ShowcaseArtByCollection)
